import { Suspense, type ComponentType } from "react";
import { PageLoader } from "../components/common/PageLoader";

/**
 * Helper to wrap lazy components in Suspense
 */
export const Loadable = (Component: ComponentType) => (
  <Suspense fallback={<PageLoader />}>
    <Component />
  </Suspense>
);

/**
 * Wrap a lazy component in Suspense and pass props (e.g. env for modules)
 */
export function LoadableWithProps<P extends object>(
  Component: ComponentType<P>,
  props: P,
) {
  return (
    <Suspense fallback={<PageLoader />}>
      <Component {...props} />
    </Suspense>
  );
}
